import React from "react";

interface SectionTitleProps {
  title: string;
  note?: string;
}

const SectionTitle = ({ title, note }: SectionTitleProps) => (
  <div className="flex min-h-[67px] items-stretch justify-between border-b border-[#d5d5d5] py-2.5 sm:h-[55px] sm:min-h-0 sm:items-center">
    <div className="flex items-stretch gap-2.5 sm:items-center sm:gap-[15px]">
      <div className="w-1 rounded-sm bg-[#1b4b86] sm:h-[35px]" />
      <div className="flex flex-col justify-center sm:flex-row sm:flex-wrap sm:items-baseline sm:gap-2.5">
        <h2 className="text-xl font-bold leading-[1.6] text-[#1b4b86] sm:text-[22px]">
          {title}
        </h2>
        {note ? (
          <span className="text-sm leading-[1.6] text-[#1b4b86] sm:text-base">
            {note}
          </span>
        ) : null}
      </div>
    </div>
  </div>
);

export default SectionTitle;
